export default __webpack_public_path__ + "static/illustration-content-desc.url-a1299910cd9f8c09c8e50d392232e8ea.svg";